export class EmbeddedDocumentPostMessageResult {
  constructor(
    public windowName: string,
    public request: string,
    public isOk?: boolean,
  ) {
  }
}
